<template>
  <!-- 底部导航bar -->
  <div id="tab_bar" class="flex">
    <router-link :to="{path: '/index'}" class="bar_item">
      <img :src="indexIcon" alt="">
      <p class="fs_12">首页</p>
    </router-link>
    <router-link :to="{path: '/book'}" class="bar_item">
      <img :src="bookIcon" alt="">
      <p class="fs_12">预约</p>
    </router-link>
    <!-- <router-link :to="{path: '/message'}" class="bar_item">
      <img :src="messageIcon" alt="">
      <p class="fs_12">资讯</p>
    </router-link> -->
     <a :href="information_url" class="bar_item">
      <img :src="messageIcon" alt="">
      <p class="fs_12">资讯</p>
    </a>
    <router-link :to="{path: '/order'}" class="bar_item">
      <img :src="orderIcon" alt="">
      <p class="fs_12">订单</p>
    </router-link>
    <router-link :to="{path: '/center'}" class="bar_item">
      <img :src="centerIcon" alt="">
      <p class="fs_12">我的</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'tabBar',
  props: {
    indexIcon:{
      default:'/static/img/icon_nav1.png',
      type: String
    },
    bookIcon:{
      default:'/static/img/icon_nav2.png',
      type: String
    },
    messageIcon:{
      default:'/static/img/icon_nav3.png',
      type: String
    },
    orderIcon:{
      default:'/static/img/icon_nav4.png',
      type: String
    },
    centerIcon:{
      default:'/static/img/icon_nav5.png',
      type: String
    },
    indexActive: {
      default: '',
      type: String
    },
    bookActive: {
      default: '',
      type: String
    },
    messageActive: {
      default: '',
      type: String
    },
    orderActive: {
      default: '',
      type: String
    },
    centerActive: {
      default: '',
      type: String
    },
  },
  data(){
    return{
      information_url:''
    }
  },
  created(){
     
      this.axios({
          url: this.api.sysset.sysset_shop,
          data:{
            
          }
      }).then((res) => {
          if (res.error === 0) {
            // 替换旧域名为新域名
            let url = res.sysset.information_url;
            if (url && url.includes('h5.liuantang.com.cn')) {
              url = url.replace('h5.liuantang.com.cn', 'h5.liuantang.com.cn');
            }
            this.information_url = url;
          }

      })
  },
  methods: {

  }
}
</script>


<style scoped>
#tab_bar {
  width: 100%;
  height: 2.5rem;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 66;
  box-shadow: 0 0 2px #efefef;
  background: #fff;
}
#tab_bar .bar_item {
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #666;
}
#tab_bar .bar_item img{
  width: 1.2rem;
}
</style>




// WEBPACK FOOTER //
// src/components/tabBar.vue